import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d9b151da"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row items-center" }
const _hoisted_2 = {
  key: 0,
  class: "secondary"
}
const _hoisted_3 = { class: "row items-center" }

import { ref, Ref } from 'vue';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'DualPane',
  props: {
    horizontal: { type: Boolean },
    vertical: { type: Boolean },
    disable: { type: Boolean },
    beforeClass: {},
    afterClass: {},
    separatorClass: {},
    expanded: { type: Boolean },
    secondaryVisible: { type: Boolean },
    dark: { type: Boolean }
  },
  emits: ["secondary-expanded"],
  setup(__props: any, { emit: __emit }) {

    const props = __props;

    const emit = __emit

    const expanded: Ref<boolean> = ref(props.expanded)
    const onButtonClicked = () => {
        expanded.value = !expanded.value;
        emit('secondary-expanded', expanded.value)
        return expanded.value;
    };

return (_ctx: any,_cache: any) => {
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_slide_transition = _resolveComponent("q-slide-transition")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_q_card, {
      "text-none": "",
      class: _normalizeClass(["iodine-padding-md iodine-dual-pane-primary", _ctx.beforeClass])
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _renderSlot(_ctx.$slots, "primary")
        ])
      ]),
      _: 3
    }, 8, ["class"]),
    (_ctx.secondaryVisible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", {
            class: _normalizeClass(["secondary__icon", {'secondary__icon--active': expanded.value}]),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (onButtonClicked()))
          }, [
            _createVNode(_component_q_icon, {
              name: "fa-solid fa-chevron-down",
              size: "12px"
            })
          ], 2),
          _createVNode(_component_q_slide_transition, { appear: "" }, {
            default: _withCtx(() => [
              (expanded.value)
                ? (_openBlock(), _createBlock(_component_q_card, {
                    key: 0,
                    "text-none": "",
                    class: _normalizeClass(["iodine-padding-md iodine-dual-pane-secondary", _ctx.afterClass])
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_3, [
                        _renderSlot(_ctx.$slots, "secondary")
                      ])
                    ]),
                    _: 3
                  }, 8, ["class"]))
                : _createCommentVNode("", true)
            ]),
            _: 3
          })
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})